import { z } from "zod";
import { agentGeoColorSchema, agentGeoFillSchema } from "./geo-shape";

export const agentPointSchema = z.object({
	x: z.number().describe("Page x coordinate"),
	y: z.number().describe("Page y coordinate"),
});

export const agentPointsSchema = z
	.array(agentPointSchema)
	.min(2)
	.describe(
		"Page-space polyline. For complex drawings use dense points " +
			"(~8–20px apart along the path). Origin is the first point.",
	);

export const agentStrokeSizeSchema = z
	.enum(["s", "m", "l", "xl"])
	.describe("Stroke size");

export const agentLineSplineSchema = z
	.enum(["line", "cubic"])
	.describe("Line interpolation style");

export const agentStrokeDashSchema = z
	.enum(["draw", "solid", "dashed", "dotted"])
	.describe(
		"Stroke style: draw for pencil, solid for fine pen, dashed or dotted for variants",
	);

export const agentDrawFillSchema = agentGeoFillSchema.describe(
	"Fill when isClosed is true (draw shapes only)",
);

export const agentDrawColorSchema = agentGeoColorSchema;
